import { RootState } from 'store';

export const contractProcessingItemsSelector = (state: RootState) => state.contractProcessing.items;
export const contractProcessingTotalItemsSelector = (state: RootState) => state.contractProcessing.totalItems;
export const contractProcessingLoadingSelector = (state: RootState): boolean => state.contractProcessing.loading;
export const contractProcessingErrorSelector = (state: RootState): boolean => state.contractProcessing.error;
export const contractProcessingBulkConfirmErrorsSelector = (state: RootState): Record<number, string> =>
  state.contractProcessing.bulkConfirmErrors;
